// rgbColor values are intentionally hardcoded hex strings — FullCalendar reads them
// as JS values and writes them into inline style attributes at runtime. CSS custom
// properties (var(...)) cannot be used in that context.
const EVENT_CSS = {
  tourDefault: { 
    bgLight:    'bg-blue-100 dark:bg-blue-200',
    bgDark:     'bg-blue-500',
    textLight:  'text-white',
    textDark:   'text-blue-500',
    rgbColor:   '#2b7fff',
  },
  tourRental: { 
    bgLight:    'bg-cyan-50',
    bgDark:     'bg-cyan-600',
    textLight:  'text-white',
    textDark:   'text-cyan-600',
    rgbColor:   '#0092b8',
  },
  tourVirtual: { 
    bgLight:    'bg-fuchsia-100',
    bgDark:     'bg-fuchsia-500',
    textLight:  'text-white',
    textDark:   'text-fuchsia-500',
    rgbColor:   '#e12afb',
  },
  userUnavailable: { 
    bgLight:    'bg-orange-100',
    bgDark:     'bg-orange-400',
    textLight:  'text-white',
    textDark:   'text-orange-400',
    rgbColor:   '#ff8904',
  },
  userPartiallyAvailable: { 
    bgLight:    'bg-green-50',
    bgDark:     'bg-green-500',
    textLight:  'text-white',
    textDark:   'text-green-600',
    rgbColor:   '#00c951',
  },
}

function eventCss(event) {
  return EVENT_CSS[event?.category?.key]
}

function tourCss(tour) {
  const keyMap = {
    default:  'tourDefault',
    rental:   'tourRental',
    virtual:  'tourVirtual',
  }
  // console.log(tour?.category, keyMap[tour?.category])
  return EVENT_CSS[keyMap[tour?.category]]
}

const SCHEDULE_CODE_BG_CLASSES = {
  A: 'bg-white       dark:bg-canvas-200',
  P: 'bg-green-500',
  U: 'bg-orange-400',
  T: 'bg-blue-600',
  R: 'bg-cyan-600',
  V: 'bg-purple-600',
  C: 'bg-red-600',
}

const SCHEDULE_CODE_TEXT_CLASSES = {
  A: 'text-canvas-400 dark:text-canvas-500',
  P: 'text-green-100',
  U: 'text-orange-200',
  T: 'text-blue-200',
  R: 'text-cyan-200',
  V: 'text-purple-200',
  C: 'text-red-200',
}

const appColors = {
  eventCss,
  tourCss,
  scheduleCellBgClass:   (code) => SCHEDULE_CODE_BG_CLASSES[code]   ?? '',
  scheduleCellTextClass: (code) => SCHEDULE_CODE_TEXT_CLASSES[code] ?? '',
}

export default appColors